// src/components/Timeline.js
import React, { useState } from "react";
import "./Timeline.scss";
import { FiFilter } from "react-icons/fi";
import { BsBoxArrowUpRight } from "react-icons/bs";

export const Timeline = () => {
  const [startDate, setStartDate] = useState("2025-04-02");
  const [endDate, setEndDate] = useState("2025-04-05");

  return (
    <div className="timeline-container">
      <div className="timeline-header">
        <button className="filter-btn">
          <FiFilter /> Filter
        </button>

        <div className="timeline-range">
          <label>Timeline Range</label>
          <div className="date-range-inputs">
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />
            <span>~</span>
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />
          </div>
        </div>

        <button className="export-btn">
          <BsBoxArrowUpRight /> Export
        </button>
      </div>

      <div className="timeline-content">
        <p>No Timeline Events Registered for selected filters</p>
      </div>
    </div>
  );
};
